import Rails from 'rails-ujs'

try {
  Rails.start()
} catch (e) {
  // rails-ujs will automatically call `start()` in when it is loaded as a bundled script
  // in production instead of as a module in development. Calling `start()` again will
  // throw an error, so we catch and ignore it here.
}
